import { createSessionLifecycle } from '@mbbe/config';

/**
 * One lifecycle per authenticated surface. The auth providers drive them; API
 * clients and the QueryClient observe them, so a request, a cached row or a
 * late profile response always belongs to exactly one account.
 */
export const opsSession = createSessionLifecycle();
export const customerSession = createSessionLifecycle();
